import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SharedService } from '../../shared/services/shared.service';
import { ErrorProcessorService } from '../../shared/services/error-processor.service';
import { IAppleReenrollmentsSummary } from '../interfaces/apple-reenrollments-summary';
import { IAppleReenrollmentsDetailsChunkResponse } from '../interfaces/apple-reenrollments-details-chunk';
import { environment } from '../../../environments/environment';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root'
})
export class AppleReenrollmentsService {

  protected readonly portalUrl = environment.apiServer.portalUrl;  

  private readonly summaryUrl      = '/admin/stats/apple-reenrollments/summary';
  private readonly detailsChunkUrl = '/admin/stats/apple-reenrollments/details-chunk';

  private readonly http = inject(HttpClient);
  private readonly sharedService = inject(SharedService);
  private readonly errorProcessorService = inject(ErrorProcessorService);  
  private readonly logger = inject(NGXLogger);  

  constructor(
  ) {}

  getAppleReenrollmentsSummary(
    brandCode: string, dateFrom: string | undefined, dateTo: string | undefined
  ): Observable<IAppleReenrollmentsSummary[]> {
    const url = this.portalUrl + this.summaryUrl;
    let params = this.setParams(brandCode, dateFrom, dateTo);
    return this.http.get<IAppleReenrollmentsSummary[]>(url, { params, responseType: 'json' })
    .pipe(
      catchError(error => {
        this.logger.error('Error fetching Apple Reenrollments summary: ', url, params);
        this.errorProcessorService.handleError(error);
        throw error;
      })
    );
  }

  getAppleReenrollmentsDetails(
    brandCode: string | undefined,
    dateFrom: string | undefined, dateTo: string | undefined,
    eventId: number, pageSize: number,
    sortDirection: string, sortField: string
  ): Observable<IAppleReenrollmentsDetailsChunkResponse> {
    const url = this.portalUrl + this.detailsChunkUrl;
    let params = this.setParams(brandCode, dateFrom, dateTo);
    params = params.set('pageSize', pageSize);
    params = params.set('sortDirection', sortDirection);
    params = params.set('sortField', sortField);
    params = params.set('eventId', eventId);
    return this.http.get<IAppleReenrollmentsDetailsChunkResponse>(url, { params, responseType: 'json' })
    .pipe(
      catchError(error => {
        this.logger.error('Error fetching Apple Reenrollments details chunk: ', url, params);
        this.errorProcessorService.handleError(error);
        throw error;
      })
    );
  }

  private setParams(brandCode: string | undefined, dateFrom: string | undefined, dateTo: string | undefined): HttpParams {
    let params = new HttpParams();
    params = params.set('request-origin', 'csr-portal');
    if (brandCode) {
      params = params.set('brandCode', brandCode);
    }
    if (dateFrom) {
      params = params.set('dateFrom', this.sharedService.getFormattedDate(dateFrom));
    }
    if (dateTo) {
      params = params.set('dateTo', this.sharedService.getFormattedDate(dateTo));
    }
    return params;
  }
}
